import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Action } from 'app/clmtlk/shared/model/action';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Impersonate } from 'app/clmtlk/shared/model/impersonate';
import { ClmtlkService } from 'app/clmtlk/shared/service/clmtlk.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorage } from 'ngx-webstorage';
import { GoogleAnalyticsService } from 'app/common/service/google-analytics.service';
import { Conversation, ConversationContact } from 'app/clmtlk/shared/model/conversationContacts';
import { ClmtlkSessionService } from 'app/clmtlk/shared/service/clmtlk-session.service';
import { HelperService } from 'app/common/service/model-helper.service';

@Component({
  selector: 'clmtlk-new-message',
  templateUrl: './new-message.component.html',
  styleUrls: ['./new-message.component.scss']
})
export class NewMessageComponent implements OnInit, AfterViewInit, OnDestroy{


  action: Action;
  ACTION = Action;
  newImpersonate: Impersonate ;
  @SessionStorage('token') private token;
  conversation: Conversation;
  originalConversation: Conversation;
  loggedUser: ConversationContact;
  @ViewChild('confirmationContent') confirmationContent: ElementRef;
  @ViewChild('messageform') messageForm: any;

  constructor(private modalService: NgbModal,
    private router: Router ,
    private clmtlkService: ClmtlkService,
    private route: ActivatedRoute,
    private clmtlkSessionService: ClmtlkSessionService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private helperService: HelperService
  ) { }

  ngOnInit() {

    // Google Analytics
    this.route.params.subscribe(params => {
          this.googleAnalyticsService.trackPage(
            `/message/${params['action']}/?a=${this.clmtlkSessionService.authToken}`);
    });

    this.route.params.subscribe(params => {

      switch (params['action']) {

        case 'new': this.action = Action.NEWCONVERSATION;
          break;
        case 'reply': this.action = Action.REPLY;
          break;
        case 'replyall': this.action = Action.REPLYALL;
          break;
        default: this.action = Action.NEWCONVERSATION;
          break;
      }

    });


    this.route.data.subscribe((data: { conversation: Conversation }) => {
      this.conversation = data.conversation;
    });

    this.loggedUser = this.clmtlkSessionService.loggedInContact;
    this.originalConversation = this.clmtlkSessionService.getConversationContext().conversation;

  };


  ngAfterViewInit(): void {
    setTimeout( () => {
    if (this.clmtlkSessionService.loggedInContact.CTC_SRC_CD !== 'st' &&
          this.clmtlkSessionService.loggedInContact.CTC_SRC_CD !== 'ai') {
        this.openCustomerConfirmationModal(this.confirmationContent);
    } }, 200);
  }

  // On {{property}} change - for 2 way binding
  onActionChange(newAction: Action) {
    this.action = newAction;
  }

  canDeactivate() {
    return this.messageForm.canDeactivate();
  }

  openCustomerConfirmationModal(content) {

    const modalOptions: any = { backdrop: 'static', keyboard: false };
    this.newImpersonate = <Impersonate>{isImpersonated: false, name: ''};
    this.modalService.open(content, modalOptions).result.then((result) => {

      if (this.newImpersonate.isImpersonated) {
        const impersonateUser: ConversationContact = this.helperService.cloneDeep(this.loggedUser);
        impersonateUser.CTC_IMPRS_NM = result.value.name;
        impersonateUser.CONV_CTC_ID = null;
        // impersonateUser.contacts.contact[0].CTC_ID = null;
        // impersonateUser.CTC_ID = null;
        this.clmtlkSessionService.impersonatedContact = impersonateUser;

      }else {
        this.clmtlkSessionService.impersonatedContact = null;
      }

    }, (reason) => {
        this.clmtlkSessionService.setConversationContext('EXISTING_THREAD_CONVERSATION'
        , this.originalConversation
        , Action.CANCEL_NEWCONVERSATION);
        const conv_id = this.originalConversation.CONV_ID;
        const thrd_id = this.originalConversation.conversationThreads.conversationThread[0].THRD_ID;
        this.router.navigate(['/convo', conv_id, 'thread', thrd_id]);
    });
  }

  ngOnDestroy(): void {
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/clmtlk/new-message/new-message.component.ts